import { updateMailing } from '../api/updateMailing';
import { setGetMailing } from './setGetMailing';

export const setUpdateMailing = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await updateMailing(params);
            alert('Сохранено');

            dispatch(setGetMailing({
                id: params.id,
                page: 1,
                pageSize: 25
            }));
        } catch (error) {
            alert(error?.response?.data?.message)
            console.log(error)
        }
    }
}